<template>
    <v-sheet
        rounded
    >
        <div v-for="(item, index) in services" :key="item.uid">
            <v-checkbox
                v-model="models[index]"
                :value="item.uid"
                density="compact"
                hide-details
            >
                <template #label class="this-is-dumb">
                    <span class="font-size-6">{{ item.label }}</span>
                </template>
            </v-checkbox>
            <div class="mx-3 font-size-7">
                {{ item.description }}
            </div>
        </div>
    </v-sheet>
</template>

<script lang="ts" setup>
    import type { ProductService } from '~/types';
    import { compact as lo_compact } from 'es-toolkit';

    const props = defineProps({
        modelValue: {
            type: Array as PropType<string[]>,
            required: false,
            default: null
        },
        services: {
            type: Array as PropType<ProductService[]>,
            required: true,
            default: () => []
        }
    });

    const emit = defineEmits([
        'update:modelValue'
    ]);
    
    const models = ref<Array<string | null>>(Array(props.services?.length).fill(null));

    const unWatchModels = watch(
        models,
        (newVal: Array<string | null>) => {
            emit('update:modelValue', lo_compact(newVal));
        },
        { deep: true }
    );

    onBeforeUnmount(() => {
        unWatchModels();
    });

</script>

<style lang="scss" scoped>
:deep(.v-checkbox-btn) {
    margin: 0 0 0 0.4rem;
    padding: 0;

    .v-label {
        margin-left: 0.4rem;
    }
}

:deep(.v-label) {
    opacity: unset;
}
</style>
